import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索社区
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            六个板块覆盖你生活的方方面面，找到你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}